var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fields-patternText',{attrs:{"spec":_vm.spec,"type":_vm.spec.type || 'date',"pattern":"[0-9]{4}-[0-9]{2}-[0-9]{2}"}})}
var staticRenderFns = []

export { render, staticRenderFns }